import { Reducer } from "redux";

import { isRoutingEvent } from "../routing_events";
import { PROCORE_PROJECTS_LOADED, ProcoreProjectsLoadedEvent } from "../../events/loaded/procore/procore_projects_loaded";
import { PUSH_TO_PROCORE_DIALOG_DISMISSED, PushToProcoreDialogDismissedEvent } from "../../events/viewer/push_to_procore_dialog_dismissed";
import { PUSH_TO_PROCORE_DIALOG_SHOWN, PushToProcoreDialogShownEvent } from "../../events/viewer/push_to_procore_dialog_shown";
import { PROCORE_COMPANIES_LOADED, ProcoreCompaniesLoadedEvent } from "../../events/loaded/procore/procore_companies_loaded";
import { PROCORE_OBSERVATION_TYPES_LOADED, ProcoreObservationTypesLoadedEvent } from "../../events/loaded/procore/procore_observation_types_loaded";

import { PROCORE_RFI_ASSIGNEES_LOADED, ProcoreRfiAssigneesLoadedEvent } from "../../events/loaded/procore/procore_rfi_assignees_loaded";
import { PROCORE_OBSERVATION_ASSIGNEES_LOADED, ProcoreObservationAssigneesLoadedEvent } from "../../events/loaded/procore/procore_observation_assignees_loaded";
import { PROCORE_COORDINATION_ASSIGNEES_LOADED, ProcoreCoordinationAssigneesLoadedEvent } from "../../events/loaded/procore/procore_coordination_assignees_loaded";
import { PROCORE_TRADES_LOADED, ProcoreTradesLoadedEvent } from "../../events/loaded/procore/procoreTradesLoaded";
import { PROCORE_LOCATIONS_LOADED, ProcoreLocationsLoadedEvent } from "../../events/loaded/procore/procoreLocationsLoaded";
import { Trade, Location, ProcoreToolsPermissionsResponse } from "avvir";
import { PROCORE_RFI_MANAGERS_LOADED, ProcoreRfiManagersLoadedEvent } from "../../events/loaded/procore/procore_rfi_managers_loaded";
import { PROCORE_TOOLS_PERMISSIONS_LOADED, ProcoreToolsPermissionsLoadedEvent } from "../../events/loaded/procore/procore_tools_permissions_loaded";

export type PushToProcoreDialogStore = {
  open: boolean;
  procoreProjects?: any[];
  procoreCompanies?: any[];
  procoreObservationTypes?: { name: string; id: any; category: string }[];
  procoreRfiAssignees?: any[];
  procoreRfiManagers?: { name: string; id: any; category: string }[];
  procoreObservationAssignees?: any[];
  pdfType?: any;
  procoreAccessToken?: any;
  selectedElements?: any;
  procoreTrades?: Trade[];
  procoreLocations?: Location[];
  procoreCoordinationAssignees?: { name: string; id: string | number }[];
  procoreToolsPermissions?: ProcoreToolsPermissionsResponse;
};

type Events =
  | ProcoreProjectsLoadedEvent
  | ProcoreCompaniesLoadedEvent
  | ProcoreObservationTypesLoadedEvent
  | ProcoreRfiAssigneesLoadedEvent
  | ProcoreObservationAssigneesLoadedEvent
  | PushToProcoreDialogDismissedEvent
  | PushToProcoreDialogShownEvent
  | ProcoreCoordinationAssigneesLoadedEvent
  | ProcoreTradesLoadedEvent
  | ProcoreLocationsLoadedEvent
  | ProcoreRfiManagersLoadedEvent
  | ProcoreToolsPermissionsLoadedEvent;

const reducePushToProcoreDialog: Reducer<PushToProcoreDialogStore, Events> = (pushToProcoreDialog = { open: false }, event) => {
  if (isRoutingEvent(event)) {
    return { open: false };
  }
  switch (event.type) {
    case PROCORE_PROJECTS_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreProjects: event.payload,
      };
    }
    case PROCORE_TOOLS_PERMISSIONS_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreToolsPermissions: event.payload,
      };
    }
    case PROCORE_COMPANIES_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreCompanies: event.payload,
      };
    }
    case PROCORE_OBSERVATION_TYPES_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreObservationTypes: event.payload,
      };
    }
    case PROCORE_RFI_ASSIGNEES_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreRfiAssignees: event.payload,
      };
    }
    case PROCORE_RFI_MANAGERS_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreRfiManagers: event.payload,
      };
    }
    case PROCORE_OBSERVATION_ASSIGNEES_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreObservationAssignees: event.payload,
      };
    }
    case PROCORE_TRADES_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreTrades: event.payload,
      };
    }
    case PROCORE_LOCATIONS_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreLocations: event.payload,
      };
    }
    case PROCORE_COORDINATION_ASSIGNEES_LOADED: {
      return {
        ...pushToProcoreDialog,
        open: true,
        procoreCoordinationAssignees: event.payload,
      };
    }
    case PUSH_TO_PROCORE_DIALOG_SHOWN: {
      return {
        ...pushToProcoreDialog,
        pdfType: event.payload.pdfType,
        procoreAccessToken: event.payload.procoreAccessToken,
        open: true,
        selectedElements: event.payload.selectedElements,
      };
    }
    case PUSH_TO_PROCORE_DIALOG_DISMISSED: {
      return {
        ...pushToProcoreDialog,
        pdfType: null,
        open: false,
      };
    }
    default: {
      return pushToProcoreDialog;
    }
  }
};

export default reducePushToProcoreDialog;
